// ** React Imports
import { ReactNode } from 'react'

// ** Next Imports

// ** MUI Imports
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

//** Custom Components Imports
import CustomTab from 'src/components/rekrutmen/CustomTab'

// ** Layout Import
import BlankLayoutAppBar from 'src/layouts/BlankLayoutWithAppBar'

const Jobs = () => {

  return (
    <Grid container>
      <Grid item xs={12} sx={{ my: 16 }}>
        <Typography
          variant='h4'
          fontWeight={600}
          textAlign={'center'}
          color={theme => theme.palette.primary.main}
          letterSpacing={0}
        >
          Rekrutmen Bankaltimtara
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomTab />
      </Grid>
    </Grid>
  )
}

Jobs.getLayout = (page: ReactNode) => <BlankLayoutAppBar>{page}</BlankLayoutAppBar>

Jobs.authGuard = false

export default Jobs
